import { handleError } from '@/utils/exception_handler';

import api from './api';

export default {

  // Users FETCH mutations on COMMENTS
  fetchComments: (context, args) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'fetchComments';

    commit(`${mutationPrefix}Pending`);

    return api.fetchComments(args)
      .then((response) => {
        dispatch('insert', { data: response.entities });

        commit(`${mutationPrefix}Success`, response.entities);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses CREATE mutations on COMMENTS
  createComment: (context, data) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'createComment';

    commit(`${mutationPrefix}Pending`);

    return api.createComment(data)
      .then((response) => {
        dispatch('insert', { data: response.entity });

        commit(`${mutationPrefix}Success`);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses UPDATE mutations on COMMENTS
  updateComment: (context, requestParams) => {
    const { commit, dispatch } = context;
    const { id } = requestParams;
    const mutationPrefix = 'updateComment';

    commit(`${mutationPrefix}Pending`, id);

    return api.updateComment(requestParams)
      .then((response) => {
        dispatch('update', response.entity);

        commit(`${mutationPrefix}Success`, id);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`), { id })
      .catch(handleError(context, `${mutationPrefix}Error`, { id }));
  },

  // Uses DELETE mutations on COMMENTS
  deleteComment: (context, id) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'deleteComment';

    commit(`${mutationPrefix}Pending`, id);

    return api.deleteComment(id)
      .then((response) => {
        dispatch('delete', id);

        commit(`${mutationPrefix}Success`, response);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`, { id }))
      .catch(handleError(context, `${mutationPrefix}Error`, { id }));
  },

  setContext: ({ commit }, payload = null) => {
    commit('setContext', payload);
  },

  openFormModal: ({ commit }, payload) => {
    commit('openFormModal', payload);
  },

  closeFormModal: ({ commit }) => {
    commit('closeFormModal');
  },

};



// WEBPACK FOOTER //
// ./src/store/modules/comment/actions.js